import React from "react";
import { REGISTER_URL, MATERIALS } from "@/lib/site";
import {
    FileText, FileType2, ClipboardList, MessageSquareQuote, HelpCircle, FileSearch,
    Table2, Layers, PenLine, ListChecks, Award,
} from "lucide-react";

const ICONS = [
    FileText,        // Workshop slides
    FileType2,       // Proposal structure guide
    ClipboardList,   // Problem statement worksheet
    MessageSquareQuote, // Interview protocol template
    HelpCircle,      // Sample interview questions
    FileSearch,      // Sample transcript
    Table2,          // Coding worksheet
    Layers,          // Theme development guide
    PenLine,         // Findings writing guide
    ListChecks,      // Publication readiness checklist
    Award,           // Certificate of attendance
];

export default function Includes() {
    return (
        <section
            id="includes"
            data-testid="includes-section"
            className="py-20 md:py-28 bg-[color:var(--beige-soft)] border-y border-[color:var(--line)]"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div>
                        <div className="font-mono-label text-[color:var(--maroon)]">
                            What Participants Receive
                        </div>
                        <h2
                            data-testid="includes-heading"
                            className="mt-3 font-serif text-4xl sm:text-5xl text-[color:var(--navy)] tracking-tight leading-tight max-w-2xl"
                            style={{ fontWeight: 500 }}
                        >
                            Practical Materials You Can Use Immediately.
                        </h2>
                        <div className="hr-gold mt-5" />
                    </div>
                    <a
                        href={REGISTER_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="includes-register-btn"
                        className="btn-maroon self-start inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm"
                    >
                        Register Now
                    </a>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                    {MATERIALS.map((it, i) => {
                        const Icon = ICONS[i] || FileText;
                        return (
                            <div
                                key={it.label}
                                data-testid={`include-item-${i + 1}`}
                                className="group rounded-2xl bg-white border border-[color:var(--line)] p-5 hover:border-[color:var(--maroon)] hover:-translate-y-0.5 transition-all shadow-sm hover:shadow-md"
                            >
                                <div className="flex items-center justify-between">
                                    <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[color:var(--navy)] text-white group-hover:bg-[color:var(--maroon)] transition-colors">
                                        <Icon className="h-5 w-5" />
                                    </span>
                                    <span className="font-mono-label text-[color:var(--gold)]">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                                <div className="mt-4 font-serif text-lg text-[color:var(--navy)] leading-tight">
                                    {it.label}
                                </div>
                                <div className="mt-1.5 text-sm text-slate-600 leading-relaxed">
                                    {it.note}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
